import { useRef, useState, useEffect } from "react"
import { X } from "lucide-react"
// import "./FaceRecognitionModal.css"

export default function FaceAuthModal({ mode, onClose, capturedImage, setCapturedImage }) {
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const [stream, setStream] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // Initialize camera when component mounts
    const startCamera = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
        })
        setStream(mediaStream)

        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream
        }
      } catch (error) {
        console.error("Error accessing camera:", error)
        alert("Could not access camera. Please check permissions.")
      }
    }

    startCamera()

    // Cleanup function to stop camera when component unmounts
    return () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop())
      }
    }
  }, [])

  const captureImage = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current
      const canvas = canvasRef.current
      const context = canvas.getContext("2d")

      if (context) {
        // Set canvas dimensions to match video
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight

        // Draw current video frame to canvas
        context.drawImage(video, 0, 0, canvas.width, canvas.height)

        // Convert canvas to data URL
        const imageData = canvas.toDataURL("image/png")
        setCapturedImage(imageData)
      }
    }
  }

  const handleSubmit = async () => {
    if (!capturedImage) {
      alert("Please capture your face first")
      return
    }

    setLoading(true)
    try {
      const endpoint = mode === "login" ? "/api/auth/face-login" : "/api/auth/face-register"

      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ faceImage: capturedImage }),
      })

      if (!response.ok) {
        throw new Error("Face authentication failed")
      }

      const data = await response.json()
      console.log("Face authentication successful", data)
      onClose()
    } catch (error) {
      console.error("Face authentication error:", error)
      alert("Face authentication failed. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const retakePhoto = () => {
    setCapturedImage(null)
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 50,
      padding: '16px'
    }}>121212
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '100%',
        padding: '24px',
        position: 'relative'
      }}>
        <div
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            color: '#6B7280',
            cursor: 'pointer'
          }}
          aria-label="Close"
        >
          <X size={24} />
        </div>
        <h2 style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          {mode === "login" ? "Login with Face" : "Register your Face"}
        </h2>
        <div style={{
          aspectRatio: '16 / 9',
          backgroundColor: '#E5E7EB',
          borderRadius: '8px',
          overflow: 'hidden',
          marginBottom: '16px',
          position: 'relative'
        }}>
          {!capturedImage ? (
            <video ref={videoRef} autoPlay playsInline muted style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }} />
          ) : (
            <img src={capturedImage || "/placeholder.svg"} alt="Captured face" style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }} />
          )}
          {/* Hidden canvas for capturing frames */}
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px'
        }}>
          {!capturedImage ? (
            <button onClick={captureImage} style={{
              width: '100%',
              padding: '8px',
              backgroundColor: '#3B82F6',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}>
              Capture Face
            </button>
          ) : (
            <>
              <button onClick={handleSubmit} disabled={loading} style={{
                width: '100%',
                padding: '8px',
                backgroundColor: loading ? '#9CA3AF' : '#3B82F6',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer'
              }}>
                {loading ? "Processing..." : mode === "login" ? "Login" : "Register"}
              </button>
              <button onClick={retakePhoto} style={{
                width: '100%',
                padding: '8px',
                backgroundColor: 'transparent',
                color: '#3B82F6',
                border: '1px solid #3B82F6',
                borderRadius: '4px',
                cursor: 'pointer'
              }}>
                Retake Photo
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

